import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import '../css/NotificationPopup.css'; // Make sure to create and import the CSS file

const NotificationPopup = ({ show, handleClose, requestPermission }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleNotifyMeClick = async () => {
    setIsLoading(true); // Show spinner
    try {
      await requestPermission(); // Request notification permission
    } catch (error) {
      console.error('Error requesting permission:', error);
    } finally {
      setIsLoading(false); // Hide spinner once token generation is done
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Catch the Next Quiz</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Ready for tomorrow's quiz? Let us notify you! 📅</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleNotifyMeClick} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              Loading...
            </>
          ) : (
            'Notify Me'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotificationPopup;
